//export class PermissionListBlade extends MfBladeComponent {
 // protected detailComponents: Array<IDetailComponent> = [ { index: 0, displayName: "Properties", component: PermissionListPageComponent, isMenuHidden: true }];
//};

import { IDataEndPoint, IEntityEndPoints, IFieldOptions, IFormOptions, IGridOptions, IColumnOptions, IEntityOptions } from '@framework/interfaces/IEntity';
import * as app from '@framework/app';
import * as models from '@common/domain/models/PermissionDTO';
import { IApiServiceCommand } from '@services/api/api.service';
export class PermissionEndPoints implements IEntityEndPoints {
	list?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/permission"}, method: "GET" };
	get?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/permission/" + serviceCommand.context.entityId}, method: "GET" };
	update?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/permission/update/" + serviceCommand.context.entityId}, method: "POST" };
	search?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/permission/lazy/"}, method: "POST" };
	pagingTotalCount?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/permission/lazyCount/"}, method: "POST" };
	insert?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/permission/create"}, method: "POST" };
	delete?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/permission/delete/"+ serviceCommand.context.entityId}, method: "POST" };
}

export class PermissionFormFields extends Array<IFieldOptions> {
	public selected: IFieldOptions = { field: "selected" };
	public organisationName: IFieldOptions = { field: "organisationName" };
	public id: IFieldOptions = { field: "id" };
	public parentId: IFieldOptions = { field: "parentId" };
	public name: IFieldOptions = { field: "name" };
	public description: IFieldOptions = { field: "description" };
	public changedBy: IFieldOptions = { field: "changedBy" };
	public datestamp: IFieldOptions = { field: "datestamp" };
	public status: IFieldOptions = { field: "status" };
	public isAssignable: IFieldOptions = { field: "isAssignable" };
	public isRequired: IFieldOptions = { field: "isRequired" };
	public appId: IFieldOptions = { field: "appId" };
	constructor() {
		super();
		this.push(this.selected);
		this.push(this.organisationName);
		this.push(this.id);
		this.push(this.parentId);
		this.push(this.name);
		this.push(this.description);
		this.push(this.changedBy);
		this.push(this.datestamp);
		this.push(this.status);
		this.push(this.isAssignable);
		this.push(this.isRequired);
		this.push(this.appId);
	}
}

export class PermissionForm implements IFormOptions {
	protected permissionFormName: string = "permissionForm";
	protected permissionFormModel: models.PermissionDTO = new models.PermissionDTO();
	protected permissionFormEndPoints: PermissionEndPoints = new PermissionEndPoints();
	protected permissionFormFields: PermissionFormFields = new PermissionFormFields();
	public get name(): string { return this.permissionFormName };
	public get model(): models.PermissionDTO { return this.permissionFormModel };
	public get endPoints(): IEntityEndPoints { return this.permissionFormEndPoints };
       public set endPoints(permissionEndPoints: IEntityEndPoints) {
		this.permissionFormEndPoints = permissionEndPoints;
	};
	public get dataEndPoint(): IDataEndPoint { return this.endPoints.get };
	public get fields(): PermissionFormFields { return this.permissionFormFields };
}

export class PermissionListColumns extends Array<IColumnOptions> {
	public selected: IColumnOptions = { field: "selected" };
	public organisationName: IColumnOptions = { field: "organisationName" };
	public id: IColumnOptions = { field: "id" };
	public parentId: IColumnOptions = { field: "parentId" };
	public name: IColumnOptions = { field: "name" };
	public description: IColumnOptions = { field: "description" };
	public changedBy: IColumnOptions = { field: "changedBy" };
	public datestamp: IColumnOptions = { field: "datestamp", template: function (fldValue) { return (new Date(fldValue)["shortDate"]()).toString(); } };
	public status: IColumnOptions = { field: "status" };
	public isAssignable: IColumnOptions = { field: "isAssignable" };
	public isRequired: IColumnOptions = { field: "isRequired" };
	public appId: IColumnOptions = { field: "appId" };
	constructor() {
		super();
		this.push(this.selected);
		this.push(this.organisationName);
		this.push(this.id);
		this.push(this.parentId);
		this.push(this.name);
		this.push(this.description);
		this.push(this.changedBy);
		this.push(this.datestamp);
		this.push(this.status);
		this.push(this.isAssignable);
		this.push(this.isRequired);
		this.push(this.appId);
	}
}

export class PermissionList implements IGridOptions {
	protected permissionListName: string = "permissionList";
	protected permissionListModel: models.PermissionDTO = new models.PermissionDTO();
	protected permissionListEndPoints: PermissionEndPoints = new PermissionEndPoints();
	protected permissionListColumns: PermissionListColumns = new PermissionListColumns();
	public permissionForm: PermissionForm = new PermissionForm();
	public get name(): string { return this.permissionListName };
	public get model(): models.PermissionDTO { return this.permissionListModel };
	public get endPoints(): IEntityEndPoints { return this.permissionListEndPoints };
	public set endPoints(permissionEndPoints: IEntityEndPoints) {
		this.permissionListEndPoints = permissionEndPoints;
		this.permissionForm.endPoints = this.endPoints;
	};
	public get dataEndPoint(): IDataEndPoint { return this.endPoints.list };
	public get columns(): PermissionListColumns { return this.permissionListColumns };
}

export class PermissionEntity implements IEntityOptions {
	protected permissionEntityName: string = "permissionEntity";
	protected permissionEntityModel: models.PermissionDTO = new models.PermissionDTO();
	protected permissionEntityEndPoints: PermissionEndPoints = new PermissionEndPoints();
	protected permissionEntityList: PermissionList = new PermissionList();
	public get name(): string { return this.permissionEntityName };
	public get model(): models.PermissionDTO { return this.permissionEntityModel };
	public get endPoints(): IEntityEndPoints { return this.permissionEntityEndPoints };
	public set endPoints(permissionEndPoints: IEntityEndPoints) {
		this.permissionEntityEndPoints = permissionEndPoints;
		this.grid.endPoints = this.endPoints;
	};
	public get grid(): PermissionList { return this.permissionEntityList };
	public get form(): PermissionForm { return this.grid.permissionForm };
	constructor(name?: string) {
		if (name) this.permissionEntityName = name;
		this.endPoints = this.permissionEntityEndPoints;
	}
};
//export class PermissionGeneratedForm extends MfGeneratedFormComponent {
 // protected detailPageComponentForm: PermissionForm = new PermissionForm();
//};

//export class PermissionListPageComponent extends ListPageComponent {
  //protected listPageComponentList: PermissionList = new  PermissionList();
  //protected showFilterColOnTable: boolean = true;
//};

//export class PermissionBlade extends MfBladeComponent {
  //protected detailComponents: Array<IDetailComponent> = [ { index: 0, displayName: "Properties", component: PermissionGeneratedForm}];
//};

